import PropTypes from 'prop-types'
import { Col, Button } from 'react-bootstrap'
import Markdown from '../../components/Markdown'

const FaqItem = ({ faqItemProps }) => {
  const { faq, index, activeIndex, setActiveIndex } = faqItemProps
  const isActive = activeIndex === faq.id

  const columnEnum = {
    XL: 3,
    LG: 2
  }

  return (
    <>
      <Col
        className={`faq-item col-12 col-lg-6 col-xl-4 mb-3 order-lg-${activeIndex ? index + 1 : index}`}
        id={`faqItem_${faq.id}`}
      >
        <div className="h-100 bg-white shadow rounded">
          <Button
            className={`accordion-button bg-white border-0 shadow-none rounded child-p-m-0${
              isActive ? '' : ' collapsed'
            }`}
            onClick={() => setActiveIndex(isActive ? null : faq.id)}
            variant="accordion"
          >
            <Markdown>{faq.title}</Markdown>
          </Button>
          {isActive && (
            <div className="d-lg-none px-3 pt-3 border-top">
              <Markdown>{faq.description}</Markdown>
            </div>
          )}
        </div>
      </Col>
      {isActive && (
        <Col
          xs={12}
          className={`d-none d-lg-block order-lg-${
            (parseInt(index / columnEnum.LG, 4) + 1) * columnEnum.LG + 1
          } arrow-lg-${index % columnEnum.LG} order-xl-${
            (parseInt(index / columnEnum.XL, 4) + 1) * columnEnum.XL + 1
          } arrow-xl-${index % columnEnum.XL}`}
        >
          <div className="px-3 pt-3 pb-2 bg-white shadow mt-n1 mb-3 rounded answer-block position-relative">
            <span className="arrow" />
            <Markdown>{faq.description}</Markdown>
          </div>
        </Col>
      )}
    </>
  )
}

FaqItem.propTypes = {
  faqItemProps: PropTypes.instanceOf(Object).isRequired
}

export default FaqItem
